export const SALES_EMAIL = "sales@hoylu.com";
